"use client";

import React from "react";

interface HighlightedTextProps {
    text: string;
    // boldWords: string[];
    className?: string;
};

export const EHighlightedText: React.FC<HighlightedTextProps> = ({
    text,
    // boldWords,
    className
}) => {
    if (!text) return null; // Handle empty text

    // Split into category (first line) and description (remaining lines)
    const [category, ...descriptionParts] = text.split("\n");
    const description = descriptionParts.join("\n"); // Preserve new lines

    return (
        category?.trim()?.toLowerCase() === "penalties"
            ?
            <div className={className}>
                <p className="font-semibold mb-2">{category}</p>
                {description ? (
                    <p className="text-sm text-gray-700  whitespace-pre-wrap">
                        {description}
                    </p>
                ) : null}
            </div>
            :
            null
    );
};




// "use client";

// import React from "react";

// interface HighlightedTextProps {
//     text: string;
//     boldWords: string[];
//     className?: string;
// };

// export const EHighlightedText: React.FC<HighlightedTextProps> = ({
//     text,
//     boldWords,
//     className
// }) => {
//     if (!text) return null; // Handle empty text

//     // Split the text into category and description based on the first newline occurrence
//     const [category, ...descriptionParts] = text.split(/\n/);
//     const description = descriptionParts.join(" ");

//     const formatText = (content: string) => {
//         return content.trim(); // Only trim at start and end, do not remove multiple spaces
//     };

//     const highlightText = (content: string) => {
//         const formattedContent = formatText(content);

//         return formattedContent.split("\n").map((line, index) => (
//             <React.Fragment key={index}>
//                 {line} {/* Do not trim spaces */}
//                 <br />
//             </React.Fragment>
//         ));
//     };


//     return (
//         category?.trim()?.toLocaleLowerCase() === "penalties"
//             ?
//             <div className={className}>
//                 <p className="font-semibold mb-2">{category}</p>
//                 {description ? <p className="text-sm text-gray-700 whitespace-pre-line">{highlightText(description)}</p> : <></>}
//             </div>
//             :
//             <></>
//     );
// };